import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";

interface IClinicWebsiteSubSectionProps {
    localizedWebsite: LocalizedTextDto;
}

function ClinicWebsiteSubSection(props: IClinicWebsiteSubSectionProps): JSX.Element {
    const { localizedWebsite } = props;

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{cacheStore.GetString("ClinicInfo_ClinicWebsiteLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteViewArray(localizedWebsite).map((item, index) => (
                    <div key={`website_${index}`} className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">URL ({item.languageName})</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <a className="link-label word-break-all" href={item.value.match(/^https?:/) ? item.value : "//" + item.value} target="_blank">{item.value}</a>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { IClinicWebsiteSubSectionProps };
export default ClinicWebsiteSubSection;
